module.exports = __webpack_public_path__ + "static/media/Tackling_1.109e22b8.png";